import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["targets-and-ranges"]!;

export function Body() {
  return (
    <>
      <p>
        Your session includes a pace or power target. For example: tempo at 5:45/km, with
        a range of 5:35–5:56/km. With a power sensor, the instruction could be 252 W,
        with a range of 244–260 W.
      </p>

      <h2>How to use it</h2>
      <p>
        Settle in near the target and stop looking at the watch every few seconds. GPS pace
        jumps around, wind and small hills move the number, and nobody runs a perfectly even
        pace. If you stay outside the range for a while, adjust gently. If you are inside it, you
        are doing the session as planned.
      </p>
      <p>
        The range is calculated from your target speed, so its width scales with the pace.
        For this tempo example, 5:45/km is 345 seconds per kilometre. A speed range of
        ±3 percent gives 345 ÷ 1.03 to 345 ÷ 0.97: about 5:35–5:56/km.
        Power uses the same percentage directly: 252 W ±3 percent gives 244.44–259.56 W,
        displayed as 244–260 W.
      </p>

      <h2>Easy runs work differently</h2>
      <p>
        Easy runs have no minimum pace. Where the reference supports it, PX7 Training gives you an
        intensity ceiling. Check your breathing and effort too: staying below a number does
        not guarantee that a run is easy in every condition. Slowing down or walking a hill is fine.
      </p>

      <h2>Why the session shows a target</h2>
      <p>
        A pace or power target tells you how to run each part of the session. Zone systems
        differ: some use measured physiological thresholds, while others use percentage bands
        around an estimate. PX7 Training records where your target comes from and shows
        the pace or power for each part of the session.
      </p>

      <h2>Hills, trails and heat</h2>
      <p>
        A pace from flat roads doesn't carry over to hills, trails, heat or strong wind. On days
        like that, use power if you have a sensor you trust, or run by breathing and effort. Use the
        target as a guide and adjust for the day.
      </p>

      <h2>Where the numbers come from</h2>
      <p>
        The purpose and structure of the session come first. PX7 Training then uses an appropriate
        personal reference: pace evidence from a recent race or suitable test, or a separate
        power reference. An estimated 10K pace is not a measured threshold. New evidence can
        update the targets without rewriting what you ran in the past.
      </p>
      <p>
        PX7 Training uses an execution range suited to the session, for example 3 percent of speed
        either way for a tempo block or 2 percent for longer, even intervals. These are
        practical tolerances chosen by PX7 Training, not scientifically established boundaries where
        the training effect suddenly changes.
      </p>
      <p>
        Your log always records what you actually ran, whatever the target said.
      </p>
    </>
  );
}
